import { useCallback, useEffect } from 'react';
import { InAppNotification } from '../../api/Types';
import { isPwaMode } from '../../utils/tokenService';
import {
  requestNotificationPermissionIfNeeded,
  showBrowserSystemNotification,
  syncAppIconBadgeForUnreadCount,
  syncWebPushSubscriptionIfNeeded,
} from '../../domains/notifications/platform-adapter';

interface UseInAppNotificationPlatformOptions {
  authorId?: number;
  unreadNotificationsCount: number;
}

export const useInAppNotificationPlatform = ({
  authorId,
  unreadNotificationsCount,
}: UseInAppNotificationPlatformOptions) => {
  const pwaMode = isPwaMode();

  const showSystemNotification = useCallback(async (notification: InAppNotification) => {
    await showBrowserSystemNotification({
      authorId,
      pwaMode,
      notification,
    });
  }, [authorId, pwaMode]);

  const syncAppIconBadge = useCallback(async (unreadCount: number) => {
    await syncAppIconBadgeForUnreadCount({
      authorId,
      unreadCount,
      pwaMode,
    });
  }, [authorId, pwaMode]);

  useEffect(() => {
    void requestNotificationPermissionIfNeeded({
      authorId,
      pwaMode,
    });
  }, [authorId, pwaMode]);

  useEffect(() => {
    void syncWebPushSubscriptionIfNeeded({
      authorId,
      pwaMode,
    });
  }, [authorId, pwaMode]);

  useEffect(() => {
    void syncAppIconBadge(unreadNotificationsCount);
  }, [authorId, syncAppIconBadge, unreadNotificationsCount]);

  return {
    showSystemNotification,
  };
};

export default useInAppNotificationPlatform;
